export enum APIErrorCode {
  UNIT_UPDATE_FAILED_FACILITY_FULL = 'UNIT_UPDATE_FAILED_FACILITY_FULL',
  INVALID_REQUEST = 'INVALID_REQUEST',
  PASSWORD_COMPLEXITY_LOW = 'PASSWORD_COMPLEXITY_LOW',
  UNACCESSIBLE_PHOTOS = 'UNACCESSIBLE_PHOTOS',
  UNACCESSIBLE_ATTACHMENTS = 'UNACCESSIBLE_ATTACHMENTS',
  MISSING_ENTITY = 'MISSING_ENTITY',
  EXISTING_CONTACT_WITH_EXTERNAL_ID = 'EXISTING_CONTACT_WITH_EXTERNAL_ID',
  UNABLE_TO_CREATE_USER_WITH_EMAIL = 'UNABLE_TO_CREATE_USER_WITH_EMAIL',
  UNABLE_TO_CREATE_INVITATION_WITH_EMAIL = 'UNABLE_TO_CREATE_INVITATION_WITH_EMAIL',
  PO_ID_DOES_NOT_MATCH_REQUIREMENTS = 'PO_ID_DOES_NOT_MATCH_REQUIREMENTS',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  DUPLICATE_COMPANY_NAME = 'DUPLICATE_COMPANY_NAME',
  INVALID_CHECKLIST_EXPORT_TYPE = 'INVALID_CHECKLIST_EXPORT_TYPE',
  UNABLE_TO_CHECK_IN_SHIPMENT = 'UNABLE_TO_CHECK_IN_SHIPMENT',
  PO_EXIST_ON_ANOTHER_COMPANY = 'PO_EXIST_ON_ANOTHER_COMPANY',
  SMS_NOTIFICATION_ERROR = 'SMS_NOTIFICATION_ERROR',
  MISSING_DRIVER_PHONE = 'MISSING_DRIVER_PHONE',
  INVALID_DRIVER_PHONE = 'INVALID_DRIVER_PHONE',
  MISSING_DELIVERY_RAMP = 'MISSING_DELIVERY_RAMP',
  FEATURE_DISABLED = 'FEATURE_DISABLED',
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  FORM_LOCATION_IN_USE = 'FORM_LOCATION_IN_USE',
  UNABLE_TO_UPDATE_SHIPMENT = 'UNABLE_TO_UPDATE_SHIPMENT',
  INVALID_UNIQUE_ID = 'INVALID_UNIQUE_ID',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  EXISTING_SERVICE_PRICE_FOR_DEPARTMENT = 'EXISTING_SERVICE_PRICE_FOR_DEPARTMENT',
  TRUCK_TYPE_LIMIT_REACHED = 'TRUCK_TYPE_LIMIT_REACHED',
  DEPARTMENT_DISABLED = 'DEPARTMENT_DISABLED',
  CHECKLIST_SERVICES_ALREADY_INITIALIZED = 'CHECKLIST_SERVICES_ALREADY_INITIALIZED',
  CHECKLIST_SERVICE_DUPLICATE_VALUE = 'CHECKLIST_SERVICE_DUPLICATE_VALUE',
  CHECKLIST_SERVICES_NOT_INITIALIZED = 'CHECKLIST_SERVICES_NOT_INITIALIZED',
}

export function isAPIErrorCode(code: string | APIErrorCode) {
  return Object.values(APIErrorCode).includes(code as APIErrorCode)
}
